import { em } from 'polished'
import styled from 'styled-components'

export default styled.img`
  max-width: ${p => (p.maxWidth ? em(p.maxWidth) : 'none')};
  display: block;

  ${p => p.theme.mq.upMd} {
    max-width: none;
  }
`
